/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIShipping } from './APIShipping';
import {
    APIShippingFromJSON,
    APIShippingFromJSONTyped,
    APIShippingToJSON,
} from './APIShipping';

/**
 * 
 * @export
 * @interface APIPaginatedShippingList
 */
export interface APIPaginatedShippingList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedShippingList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedShippingList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedShippingList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIShipping>}
     * @memberof APIPaginatedShippingList
     */
    results: Array<APIShipping>;
}

/**
 * Check if a given object implements the APIPaginatedShippingList interface.
 */
export function instanceOfAPIPaginatedShippingList(value: object): value is APIPaginatedShippingList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedShippingListFromJSON(json: any): APIPaginatedShippingList {
    return APIPaginatedShippingListFromJSONTyped(json, false);
}

export function APIPaginatedShippingListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedShippingList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIShippingFromJSON)),
    };
}

export function APIPaginatedShippingListToJSON(value?: APIPaginatedShippingList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIShippingToJSON)),
    };
}

